import { topResults, allResults, recentResults, moreResults } from "../strings.locstring.json";
import loc from "owa-localize";
import type GroupHeader from "../type/GroupHeader";
import { NoGroupHeaderId } from "../type/GroupHeaderId";
import type { SearchTableQuery } from "owa-mail-list-search";
import type { TableView } from "owa-mail-list-store";
import { MailRowDataPropertyGetter } from "owa-mail-list-store";

/**
 * Get GroupHeader for row in search table
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSearchTable(rowKey: string, tableView: TableView): GroupHeader {
    const searchSortOrder = (tableView.tableQuery as SearchTableQuery).searchSortOrder;
    
    if (searchSortOrder === "Hybrid" &&
        !tableView.recentRowKeys?.length &&
        !tableView.moreResultsRowKeys?.length) {
        return {
            headerText: () => "",
            headerId: NoGroupHeaderId.None,
        };
    }
    
    // Checked before the sort order because these rows are sourced from a different backend and
    // deliberately ordered by date rather than by relevance, so the served table's sort order says
    // nothing about them.
    if (tableView.recentRowKeys?.includes(rowKey)) {
        const recentHeaderText = loc(recentResults);
        
        return {
            headerText: () => recentHeaderText,
            headerId: recentHeaderText,
        };
    }
    
    if (tableView.moreResultsRowKeys?.includes(rowKey)) {
        const moreResultsHeaderText = loc(moreResults);
        
        return {
            headerText: () => moreResultsHeaderText,
            headerId: moreResultsHeaderText,
        };
    }
    
    const sortOrder = MailRowDataPropertyGetter.getExecuteSearchSortOrder(rowKey, tableView);
    const currentHeaderText = <any>sortOrder == 1 || sortOrder === "Relevance" ? loc(topResults) : loc(allResults);
    
    return {
        headerText: () => currentHeaderText,
        headerId: currentHeaderText,
    };
}
